import { i18n } from '@/plugins/i18n'

export const sorts = [
    {
        label: i18n.t('sorter.desc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'desc',
            column: 'id'
        }
    },
    {
        label: i18n.t('sorter.asc', {attr: i18n.t('attributes.created_at')}),
        value: {
            direction: 'asc',
            column: 'id'
        }
    },
]